<template>
    <div class="flex-grow-1 d-flex flex-column">
        <div class="grid-count mb-3 d-flex justify-content-between">
            <span class="align-self-end">
                {{ count }} Results
                <span class="font-weight-bold"
                      v-if="selectedCount > 0">
                    | {{ selectedCount }} selected
                </span>
            </span>
            <div class="d-flex align-content-center">
                <reset-filters
                        @click="resetGridToDefaultOptions"></reset-filters>
                <refresh-button
                        @click="refresh"
                        :spinning="refreshing"
                >
                </refresh-button>
            </div>
        </div>
        <div class="flex-grow-1 d-flex">
            <ag-grid-vue
                    :style="'width: ' + gridWidth +'%;'"
                    class="ag-theme-balham"

                    :gridOptions="gridOptions"
                    :defaultColDef="defaultColDef"
                    :columnDefs="columnDefs"
                    :columnTypes="columnTypes"
                    :rowData="rowData"

                    @gridReady="onGridReady"
                    :floatingFilter="floatingFilter"
                    :cacheQuickFilter="cacheQuickFilter"
                    :side-bar="sideBarDef"

                    :suppressExcelExport="suppressExcelExport"
                    :suppressContextMenu="true"

                    :isExternalFilterPresent="isExternalFilterActive"
                    :doesExternalFilterPass="doesExternalFilterPass"

                    :headerHeight="rowHeight"
                    :rowHeight="rowHeight"
            >
            </ag-grid-vue>
        </div>
    </div>
</template>

<script>
import {
  propertyAssetsGridDefaultColDef as gridDefaultColDef,
  propertyAssetsGridColumnTypes as columnTypes,
  getPropertyAssetsGridColumns as gridColumns,
} from '@/services/Assets/PropertyAssetsGridConfig';
import GridMixin from '@/components/Grid/GridMixin';
import Assets from "@/services/Assets/Assets";
import dayjs from 'dayjs';
import RefreshButton from '@/components/Grid/RefreshButton';
import ResetFilters from '@/components/Grid/ResetFilters';

export default {
  name: 'Property-Action-Grid',
  components: {
    RefreshButton,
    ResetFilters,
  },
  mixins: [GridMixin],
  props: {
    property: {
      required: true,
      type: Object,
    },
    shown: {
      type: Boolean,
    },
  },
  data() {
    return {
      rowData: [],
      defaultColDef: gridDefaultColDef,
      columnDefs: null,
      columnTypes,
      clientActionId: null,
      modals: {
        action: {
          visible: false,
        },
      },
    };
  },
  created() {
    this.columnDefs = gridColumns().filter(this.filterColumn);
  },
  methods: {
    postGridReady() {
      this.refresh();
    },

    /**
     * Filter columns based on permissions
     *
     * @param {Object} column
     */
    filterColumn(column) {
      return !(column.field === 'dueDate' && !this.$can(
        this.$perm.ACTIONS_VIEW_ACTION_DUE_DATE,
        this.$perm.PERMISSION_TYPE_ACTION,
      ));
    },

    async refresh() {
      this.refreshing = true;
      const { data } = await Assets.propertyAssets(this.property.propertyId, {});
      this.rowData = data.data;
      this.refreshing = false;
    },

    doesExternalFilterPass(node) {
      return true;
    },

    isExternalFilterActive() {
      return true;
    },
  },
  watch: {
    shown() {
      this.gridApi.sizeColumnsToFit();
    },
  },
};
</script>
